import { Box, ScrollArea, SimpleGrid, Stack } from '@mantine/core';
import H3Medium from 'components/typography/H3Medium';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import {
  COOLING_DEVICE_TYPE,
  ELECTRIC_DEVICE_TYPE,
  FIRE_SAFETY_DEVICE_TYPE,
  GAS_DEVICE_TYPE,
  HEATING_DEVICE_TYPE,
  LIFTING_DEVICE_TYPE,
  MEDICAL_DEVICE_TYPE,
  OTHER_DEVICE_TYPE,
  PRESSURE_DEVICE_TYPE,
  VENTILATION_DEVICE_TYPE,
  WEAK_CURRENT_DEVICE_TYPE,
} from 'model/DeviceType';
import DeviceTypeBox from 'pages/devices-module/device-types/DeviceTypeBox';
import { useMemo } from 'react';
import { useResponsiveDesign } from 'hooks/use-responsive-design';

/**
 * The page for listing all device types.
 */
export default function DeviceTypesPage() {
  const { isTablet } = useResponsiveDesign();
  const gridBreakpoints = useMemo(
    () => [
      { maxWidth: 1200, cols: 3 },
      { maxWidth: 900, cols: 2 },
      { maxWidth: 600, cols: 1 },
    ],
    []
  );

  return (
    <DashboardLayout
      height="screen"
      title="Typy zariadení"
      breadcrumbs={[{ title: 'Nastavenia' }, { title: 'Typy zariadení' }]}
    >
      <Box bg="white" h="100%" style={{ borderRadius: '4px' }} py={24} px={isTablet ? 20 : 40}>
        <ScrollArea h="100%">
          <Stack spacing={24}>
            <H3Medium color="gray.7">Skupiny zariadení v zmysle VTZ a UTZ</H3Medium>
            <SimpleGrid cols={4} spacing={24} breakpoints={gridBreakpoints}>
              <DeviceTypeBox deviceTypeId={ELECTRIC_DEVICE_TYPE.id} />
              <DeviceTypeBox deviceTypeId={GAS_DEVICE_TYPE.id} />
              <DeviceTypeBox deviceTypeId={PRESSURE_DEVICE_TYPE.id} />
              <DeviceTypeBox deviceTypeId={LIFTING_DEVICE_TYPE.id} />
            </SimpleGrid>
            <H3Medium mt={16} color="gray.7">
              Ostatné skupiny zariadení
            </H3Medium>
            <SimpleGrid cols={4} spacing={24} breakpoints={gridBreakpoints}>
              <DeviceTypeBox deviceTypeId={WEAK_CURRENT_DEVICE_TYPE.id} />
              <DeviceTypeBox deviceTypeId={HEATING_DEVICE_TYPE.id} />
              <DeviceTypeBox deviceTypeId={FIRE_SAFETY_DEVICE_TYPE.id} />
              <DeviceTypeBox deviceTypeId={VENTILATION_DEVICE_TYPE.id} />
              <DeviceTypeBox deviceTypeId={COOLING_DEVICE_TYPE.id} />
              <DeviceTypeBox deviceTypeId={MEDICAL_DEVICE_TYPE.id} />
              <DeviceTypeBox deviceTypeId={OTHER_DEVICE_TYPE.id} />
            </SimpleGrid>
          </Stack>
        </ScrollArea>
      </Box>
    </DashboardLayout>
  );
}
